import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPushSubscriptionState, getPushSubscriptions } from './selectors';
import { togglePushSubscription, registerPushSubscription, unregisterPushSubscription, updatePushSubscriptions } from './actions';
import { PushSubscriptionState } from './types';
import { CompliantLocalStorageKeys } from '@wix/da-react-context/pkg/compliantLocalStorage/redux/constants';
import { useBooleanLocalStorageValue } from '@wix/da-react-context/pkg/compliantLocalStorage/hooks';
export function usePushSubscription() {
    const state = useSelector(getPushSubscriptionState);
    const [isSubscribedLocally, setSubscribedLocally] = useBooleanLocalStorageValue(CompliantLocalStorageKeys.PWA_NOTIFICATIONS);
    // set initial value if unset
    if (state === PushSubscriptionState.SUBSCRIBED && !isSubscribedLocally) {
        setSubscribedLocally(true);
    }
    const dispatch = useDispatch();
    const toggle = useCallback(()=>{
        dispatch(togglePushSubscription());
        setSubscribedLocally(!isSubscribedLocally);
    }, [
        dispatch,
        setSubscribedLocally,
        isSubscribedLocally
    ]);
    const register = useCallback(()=>{
        dispatch(registerPushSubscription());
    }, [
        dispatch
    ]);
    const unregister = useCallback(()=>{
        dispatch(unregisterPushSubscription());
        setSubscribedLocally(false);
    }, [
        dispatch,
        setSubscribedLocally
    ]);
    return {
        state,
        isSubscribed: state === PushSubscriptionState.SUBSCRIBED || isSubscribedLocally,
        canToggle: [
            PushSubscriptionState.SUBSCRIBED,
            PushSubscriptionState.READY_TO_SUBSCRIBE
        ].includes(state),
        toggle,
        register,
        unregister
    };
}
// get a PushSubscriptions map to see which notifications the user subscribed to
export function usePushSubscriptions() {
    const dispatch = useDispatch();
    const subscriptions = useSelector(getPushSubscriptions);
    const setSubscriptions = useCallback((updatedSubscriptions)=>{
        dispatch(updatePushSubscriptions(updatedSubscriptions));
    }, [
        dispatch
    ]);
    return [
        subscriptions,
        setSubscriptions
    ];
}

//# sourceMappingURL=hooks.js.map